import i18n from '@/i18n';
import validationEchecAffectation from './validationEchecAffectation';

export default function gestionErreurAffectation(ligneCommande) {
  let messagesRetour = validationEchecAffectation(ligneCommande.messageEchecAffectation);
  if (!messagesRetour) messagesRetour = [];
  if (ligneCommande.facesAffectees === ligneCommande.facesVendues) {
    return messagesRetour;
  }
  if (ligneCommande.facesVendues > ligneCommande.facesReel) {
    messagesRetour.push(i18n.t('listeDemande.tab.echec.plusVenduesQueReelles'));
  }
  if (ligneCommande.facesAffecteesTheorique > ligneCommande.facesAffectees) {
    let explication = false;
    if (ligneCommande.facesAffecteesManuelTheorique > 0) {
      if (ligneCommande.facesAffecteesManuelTheorique === 1) {
        messagesRetour.push(i18n.t('listeDemande.tab.echec.nbManuel'));
      } else {
        messagesRetour.push(i18n.t('listeDemande.tab.echec.nbManuels', { nbManuels: ligneCommande.facesAffecteesManuelTheorique }));
      }
      explication = true;
    }

    const nbAffichee = (ligneCommande.facesAffecteesAfficheTheorique ? ligneCommande
      .facesAffecteesAfficheTheorique : 0)
    + (ligneCommande.facesAffecteesLaisserEnPlaceVenteTheorique ? ligneCommande
      .facesAffecteesLaisserEnPlaceVenteTheorique : 0);
    if (nbAffichee > 0) {
      if (nbAffichee === 1) {
        messagesRetour.push(i18n.t('listeDemande.tab.echec.nbAffichee'));
      } else {
        messagesRetour.push(i18n.t('listeDemande.tab.echec.nbAffichees', { nbAffichees: nbAffichee }));
      }
      explication = true;
    }

    if (ligneCommande.facesAffecteesLaisserEnPlaceTheorique > 0) {
      if (ligneCommande.facesAffecteesLaisserEnPlaceTheorique === 1) {
        messagesRetour.push(i18n.t('listeDemande.tab.echec.nbLaisseEnPlace'));
      } else {
        messagesRetour.push(i18n.t('listeDemande.tab.echec.nbLaisseEnPlaces', { nbLaisseEnPlaces: ligneCommande.facesAffecteesLaisserEnPlaceTheorique }));
      }
      explication = true;
    }
    if (!explication) {
      messagesRetour.push(i18n.t('listeDemande.tab.echec.plusTheorique'));
    }
  } else if (ligneCommande.facesVendues < ligneCommande.facesReel) {
    messagesRetour.push(i18n.t('listeDemande.tab.echec.plusReellesQueVendues'));
  }
  return messagesRetour;
}
